import "./App.css";
import Navbar from "./components/navbar/Navbar";
import { HomePage } from "./components/home/HomePage";
import Footer from "./components/footer/Footer";
import SEO from "./components/SEO/SEO";

function App() {
  return (
    <div className="App">
      <SEO
        title="Home"
        description="Redefining Comfort with Trusted Home Services. Professional cleaning and home services by MaidEaze."
        canonicalUrl="https://maideaze.com"
      />
      <>
        <Navbar />
        <HomePage />
        <br />
        <br />
        <br />
        <Footer />
      </>
    </div>
  );
}

export default App;
